/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Serializer for user with invitation information.
 */
export interface UserWithInvitation { 
    /**
     * Celé jméno (příjmení + jméno)
     */
    name: string;
    /**
     * Email uživatele
     */
    email: string;
    /**
     * Role uživatele (teacher, manager, director)
     */
    role: string;
    /**
     * Datum vytvoření pozvánky nebo aktivace účtu
     */
    invited?: Date;
    /**
     * Datum posledního přihlášení (pouze pro aktivní uživatele)
     */
    lastLogin?: Date;
    /**
     * True pokud jde o skutečného uživatele, False pokud jen o pozvánku
     */
    isUser: boolean;
    /**
     * ID uživatele (pouze pro aktivní uživatele)
     */
    userId?: number;
    /**
     * ID pedagoga (pouze pro aktivní uživatele)
     */
    teacherId?: number;
    /**
     * ID pozvánky (pouze pro čekající pozvánky)
     */
    invitationId?: string;
    /**
     * Zda je účet aktivní (False pro čekající pozvánky)
     */
    isActive: boolean;
    /**
     * Zda je pozvánka expirovaná (pouze pro čekající pozvánky)
     */
    isExpired?: boolean;
}